import formbird from './assets/img/icons/common/formbird.png'
import site from './assets/img/icons/common/site.png'
import t360 from './assets/img/icons/common/t360.png'
import flood from './assets/img/icons/common/flood.svg'
import element from './assets/img/icons/common/element.png'
import katalon from './assets/img/icons/common/katalon.png'
import kobiton from './assets/img/icons/common/kobiton.svg'
import agreementExpress from './assets/img/icons/common/agreementExpress.svg'
import LNI from './assets/img/icons/common/LNI.png'
import tellihealth from './assets/img/icons/common/tellihealth.svg'
import birdseye from './assets/img/icons/common/birdseye.png'

export const greetings = {
  name: 'phileba',
  description:
    'I love exploring new technologies, I like to stay on top of latest trends.',
}

export const openSource = {
  githubUserName: 'lebaphi',
}

export const contact = {
  location: 'Ho Chi Minh City, Vietnam',
  bio: 'Education is not a preparation for life, education is life itself!',
}

export const socialLinks = {
  facebook: 'https://www.facebook.com/DustinLe2605',
  instagram: 'https://www.instagram.com/phi.le.ba',
  github: 'https://github.com/lebaphi',
  linkedin: 'https://www.linkedin.com/in/phi-le-ba-7a1753138',
  upwork: 'https://www.upwork.com/freelancers/phileba',
}

export const skillsSection = {
  title: 'What I do',
  subTitle:
    'Senior full-stack engineer. Frontend, backend, delivery — then AI when it actually helps ship.',
  skills: [
    {
      title: 'Frontend',
      desc:
        'Ship production UIs in React (Redux, MUI) and Angular — the screens people actually use, not just the API behind them.',
    },
    {
      title: 'Backend',
      desc:
        'Design and ship services, APIs, and data pipelines in Node.js and Java Spring that hold up in production.',
    },
    {
      title: 'AI-native work',
      desc:
        'Use Claude, Cursor, and Copilot to move faster — and ship production LLM pipelines (Bedrock, structured outputs, HIPAA-aware flows) when the problem needs it.',
    },
  ],

  softwareSkills: [
    {
      skillName: 'html-5',
      fontAwesomeClassname: 'vscode-icons:file-type-html',
    },
    {
      skillName: 'css3',
      fontAwesomeClassname: 'vscode-icons:file-type-css',
    },
    {
      skillName: 'sass',
      fontAwesomeClassname: 'logos:sass',
    },
    {
      skillName: 'java',
      fontAwesomeClassname: 'logos:java',
    },
    {
      skillName: 'python',
      fontAwesomeClassname: 'logos:python',
    },
    {
      skillName: 'JavaScript',
      fontAwesomeClassname: 'logos:javascript',
    },
    {
      skillName: 'TypeScript',
      fontAwesomeClassname: 'logos:typescript-icon',
    },
    {
      skillName: 'nodejs',
      fontAwesomeClassname: 'logos:nodejs-icon',
    },
    {
      skillName: 'php',
      fontAwesomeClassname: 'logos:php',
    },
    {
      skillName: 'reactjs',
      fontAwesomeClassname: 'vscode-icons:file-type-reactjs',
    },
    {
      skillName: 'angular',
      fontAwesomeClassname: 'vscode-icons:file-type-angular',
    },
    {
      skillName: 'ionic',
      fontAwesomeClassname: 'logos:ionic-icon',
    },
    {
      skillName: 'npm',
      fontAwesomeClassname: 'vscode-icons:file-type-npm',
    },
    {
      skillName: 'yarn',
      fontAwesomeClassname: 'logos:yarn',
    },
    {
      skillName: 'sql-database',
      fontAwesomeClassname: 'vscode-icons:file-type-sql',
    },
    {
      skillName: 'postgres',
      fontAwesomeClassname: 'logos:postgresql',
    },
    {
      skillName: 'redis',
      fontAwesomeClassname: 'logos:redis',
    },
    {
      skillName: 'mongoDB',
      fontAwesomeClassname: 'vscode-icons:file-type-mongo',
    },
    {
      skillName: 'aws',
      fontAwesomeClassname: 'logos:aws',
    },
    {
      skillName: 'firebase',
      fontAwesomeClassname: 'logos:firebase',
    },
    {
      skillName: 'git',
      fontAwesomeClassname: 'logos:git-icon',
    },
    {
      skillName: 'docker',
      fontAwesomeClassname: 'logos:docker-icon',
    },
    {
      skillName: 'azure',
      fontAwesomeClassname: 'logos:microsoft-azure',
    },
    {
      skillName: 'helm',
      fontAwesomeClassname: 'vscode-icons:file-type-helm',
    },
    {
      skillName: 'kubenetes',
      fontAwesomeClassname: 'logos:kubernetes',
    },
    {
      skillName: 'terraform',
      fontAwesomeClassname: 'vscode-icons:file-type-terraform',
    },
    {
      skillName: 'kafka',
      fontAwesomeClassname: 'logos:kafka',
    },
    {
      skillName: 'spring',
      fontAwesomeClassname: 'logos:spring-icon',
    }
  ],
}

export const educationInfo = [
  {
    schoolName: 'International University - Vietnam National University',
    subHeader: 'Bachelor of Science in Computer Science',
    duration: '2007 - 2011',
    desc: 'Scholarship in 2010. Ranked top 10% in the program.',
  },
]

export const experience = [
  {
    role: 'Senior Software Engineer',
    company: 'Tellihealth',
    companylogo: tellihealth,
    date: 'Nov 2025 – Aug 2026',
    desc:
      'Healthcare RPM/CCM platform — HIPAA multi-tenant data plane unifying Salesforce CRM and Evelyn/Node.js RPM.',
    impact: [
      'Shipped React + Node product work alongside an 11-stage ETL/schema pipeline mixing deterministic code with LLM steps.',
      'Mapped 5,740 Salesforce fields to 84 entities (9,113 mappings); ~70% of dbt SQL auto-generated with a 90% quality gate per entity.',
      'Implemented HIPAA controls (audit logging, tenant isolation, PHI deny-lists) and a FHIR R4 indexer over ~9K candidate pairs.',
    ],
    tech: [
      'React',
      'Node.js',
      'AWS Lambda',
      'PostgreSQL',
      'Dagster',
      'dbt',
      'Claude',
    ],
  },
  {
    role: 'Senior Software Engineer',
    company: 'Birdseye Security',
    companylogo: birdseye,
    date: 'Sep 2024 – Nov 2025',
    desc: 'Facility security and yard-operations platform — visibility, control, and automation.',
    impact: [
      'Built API features and event-driven sync across systems on Spring Boot + RabbitMQ.',
      'Shipped React UI work and tightened code quality / delivery on a live production platform.',
    ],
    tech: ['React', 'Java Spring Boot', 'PostgreSQL', 'RabbitMQ', 'Claude'],
  },
  {
    role: 'Senior Software Engineer',
    company: 'LexisNexis',
    companylogo: LNI,
    date: 'Jul 2022 – Sep 2024',
    desc: 'Insurance Rules Cloud Migration — cloudifying production microservices at RELX.',
    impact: [
      'Cloudified services (LGW, MBSI Support/Billing, LNDS-Billing, LRCRX) and owned feature work plus production support.',
      'Improved product quality and code structure across the migrated Spring Boot stack.',
    ],
    tech: [
      'Java Spring Boot',
      'Terraform',
      'MySQL',
      'Docker',
      'GitHub Actions',
    ],
  },
  {
    role: 'Senior Software Engineer',
    company: 'Agreement Express',
    companylogo: agreementExpress,
    date: 'Oct 2021 – Aug 2022',
    desc: 'SaaS for automated onboarding and underwriting in financial services.',
    impact: [
      'Shipped product features across a React + Spring stack for onboarding workflows.',
      'Worked against both MySQL and Mongo while keeping a mixed React / Polymer UI moving.',
    ],
    tech: ['React', 'Java Spring', 'MySQL', 'Polymer', 'MongoDB'],
  },
  {
    role: 'Senior Software Engineer',
    company: 'Kobiton',
    companylogo: kobiton,
    date: 'Apr 2021 – Oct 2021',
    desc: 'Enterprise mobile-testing platform.',
    impact: [
      'Built product features on a React + Node microservices platform.',
      'Worked on search and indexing with Elasticsearch, with Jest covering the critical paths.',
    ],
    tech: ['React', 'Node.js', 'Microservices', 'Elasticsearch', 'Jest'],
  },
  {
    role: 'Senior Software Engineer',
    company: 'Katalon',
    companylogo: katalon,
    date: 'Mar 2021 – Apr 2021',
    desc: 'Test-automation platform — short engagement on a new-feature POC.',
    impact: [
      'Shipped a POC for a new product feature on React, Spring, and Postgres.',
    ],
    tech: ['React', 'Java Spring', 'PostgreSQL'],
  },
  {
    role: 'Senior Software Engineer',
    company: 'Flood',
    companylogo: flood,
    date: 'Dec 2018 – Apr 2021',
    desc: 'Globally distributed load-testing platform (JMeter, Gatling, Selenium, Element).',
    impact: [
      'Owned Organization, team permissions, and SSO with Auth0.',
      'Integrated observability: Dynatrace, New Relic, AppDynamics, and Datadog.',
    ],
    tech: ['Ember', 'TypeScript', 'Auth0', 'Jest'],
  },
  {
    role: 'Senior Software Engineer',
    company: 'Flood — Element',
    companylogo: element,
    date: 'Dec 2018 – Apr 2021',
    desc: 'Browser-based load generation tool.',
    impact: [
      'Owned feature work across Element 1.5 and 2.0.',
      'Built scalable browser load generation on Puppeteer and Playwright, packaged with Docker.',
    ],
    tech: ['TypeScript', 'Node.js', 'Puppeteer', 'Playwright', 'Docker', 'Jest'],
  },
  {
    role: 'Fullstack Software Engineer',
    company: '360Safety',
    companylogo: t360,
    date: 'Feb 2019 – Mar 2020',
    desc: 'Resource, training, and issue-tracking system built to customer demand.',
    impact: [
      'Built the full application: resources, training, and issue tracking.',
      'Integrated AWS S3, SES, and JWT auth; ran the system on EC2.',
    ],
    tech: ['PHP', 'JavaScript', 'MySQL', 'AWS S3', 'AWS SES', 'EC2'],
  },
  {
    role: 'Fullstack Software Engineer',
    company: 'SITE',
    companylogo: site,
    date: 'Sep 2018 – Feb 2019',
    desc: 'Platform to manage client sites at scale and flag fixes with AI.',
    impact: [
      'Owned backend structure: quality review, refactoring, and new features.',
      'Shipped work on a React + Hapi + Mongo stack, with assets on S3.',
    ],
    tech: ['React', 'Hapi', 'MongoDB', 'S3', 'Jest'],
  },
  {
    role: 'Software Engineer',
    company: 'Fieldtec / Formbird',
    companylogo: formbird,
    date: 'Jul 2014 – Jul 2018',
    desc: 'Business platform built from scratch with the team.',
    impact: [
      'Built Formbird from the ground up — product, data, and delivery.',
      'Owned full-stack work on AngularJS, Node, Mongo, and Elasticsearch, plus the test suite.',
    ],
    tech: [
      'AngularJS',
      'Node.js',
      'MongoDB',
      'Elasticsearch',
      'Webpack',
      'Karma',
      'Jasmine',
      'Protractor',
    ],
  },
]

export const projects = [
  {
    name: 'lorem ipsum',
    desc: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua',
  },
]
